import {EXCLUDED_VENDORS_FROM_HIDE_PRICES} from "../ab_testing/constants/excluded_vendors_from_hide_prices";

/**
 * Checks if a vendor is excluded from the A/B test that hides prices.
 * @param vendorId - The vendor ID to check.
 * @returns true if the vendor is excluded (prices always visible), false otherwise.
 */
export const isVendorExcludedFromHidePrices = (vendorId: number): boolean => {
    return EXCLUDED_VENDORS_FROM_HIDE_PRICES.includes(vendorId);
};
